(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AsyncAfWrapper", [], factory);
	else if(typeof exports === 'object')
		exports["AsyncAfWrapper"] = factory();
	else
		root["AsyncAfWrapper"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 